import { catchUpSequence } from "./legacy-sequence-sync.js";
/** 只补读当前会话，不调用会把其他会话一并标为已读的旧unread接口。 */
export async function catchUpLegacyMessages({ getCurrent, sessionId, getMessages, currentUserId, markRead, getSequenceMessages, markSpecific, canMarkRead = () => true, fromId, onMore = () => {}, onRead = () => {} }) {
  if (getSequenceMessages && await catchUpSequence({ getCurrent, sessionId, getSequenceMessages, markSpecific, canMarkRead, currentUserId, onMore: () => onMore(fromId), onRead })) return;
  if (fromId === 0 && getCurrent()) getCurrent().legacyReconciliation = { epoch: getCurrent().syncEpoch, candidates: new Set(getCurrent().messages.filter(m => m.id).map(m => String(m.id))), seen: new Set() };
  let cursor = fromId ?? getCurrent()?.lastMessageId ?? 0;
  for (let page = 0; page < 8; page++) {
    const current = getCurrent();
    if (!current || String(current.sessionId) !== String(sessionId)) return;
    const epoch = current.syncEpoch;
    const afterId = cursor;
    const response = await getMessages(sessionId, { afterId });
    const target = getCurrent();
    if (!target || String(target.sessionId) !== String(sessionId) || target.syncEpoch !== epoch) return;
    if (Number(response?.code) !== 200) throw new Error(response?.msg || "消息同步失败");
    const items = Array.isArray(response.data) ? response.data : response.data?.list || [];
    const ids = new Set(target.messages.filter(m => m.id).map(m => String(m.id)));
    const reconciliation = target.legacyReconciliation;
    for (const item of items) {
      if (reconciliation && reconciliation.epoch === epoch) reconciliation.seen.add(String(item.id));
      if (!ids.has(String(item.id))) {
        target.messages.push({ id: item.id, content: item.content || "", isSelf: String(item.senderUserId) === String(currentUserId), time: item.sendTime || item.createTime });
        ids.add(String(item.id));
      }
      cursor = Math.max(cursor, Number(item.id) || 0);
      target.lastMessageId = Math.max(target.lastMessageId || 0, cursor);
    }
    if (items.length) target.messages.sort((a, b) => a.id && b.id ? Number(a.id) - Number(b.id) : a.id ? -1 : b.id ? 1 : 0);
    if (items.length && canMarkRead()) {
      if (markSpecific) {
        let result;
        try { result = await markSpecific(sessionId, items.map(m => String(m.id))); }
        catch (error) { if (error.response?.status === 404) result = { code: 404 }; else throw error; }
        if (Number(result?.code) === 404 && markRead) await markRead(sessionId, currentUserId);
        else if (Number(result?.code) !== 200) throw new Error("消息已读确认失败");
        onRead();
      } else if (markRead) { await markRead(sessionId, currentUserId); onRead(); }
    }
    if (getCurrent() !== target || target.syncEpoch !== epoch) return;
    if (items.length < 100 || cursor <= afterId) {
      if (reconciliation && reconciliation.epoch === epoch) {
        target.messages = target.messages.filter(m => !m.id || !reconciliation.candidates.has(String(m.id)) || reconciliation.seen.has(String(m.id)));
        target.legacyReconciliation = null;
      }
      return;
    }
  }
  onMore(cursor);
}
